import {
    useRef
} from 'react';

import { SimpleGrid, Text } from '@mantine/core';
import { Link } from 'react-router-dom';

import { useCustomers } from '../hooks/useCustomers.ts';
import { useCustomersSelection } from '../hooks/useCustomersSelection.ts';
import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import { DataTableColumn } from "mantine-datatable";
import { DataTableTokenPagination } from "../../../components/DataTableTokenPagination.tsx";
import { Customer } from '../types';

export const RecordsTable = () => {
    const {selectedRecords, setSelectedRecords} = useCustomersSelection();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useCustomers();



    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const columns: DataTableColumn<Customer>[] = [
        {
            accessor: 'name',
            title: 'Customer',
            render: (record: Customer) => (
                <Link to={`/customers/${record.id}`} style={{ textDecoration: 'none' }}>
                    <Text c="blue" style={{ cursor: 'pointer' }}>
                        {record.name}
                    </Text>
                </Link>
            )
        },
        { accessor: 'status', title: 'Status' },
        { accessor: 'created', title: 'Created' },
    ];

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword} />

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken} handleLoadMore={fetchRecords} />

        </SimpleGrid>
    );
};